// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608271234/js/" + chunkId + "." + {"44":"03e3c535","225":"d3120d82","481":"2e67ba94","486":"650c5eb2","770":"f7094fde"}[chunkId] + ".0.8627740620013495.chunk.js";
};